import React from "react";
import { NavLink } from "react-router-dom";

let date = new Date().getFullYear();
const Footer = () => {
  const goToTop = () => {
    window.scrollTo({ top: 0, behaviour: "smooth" });
  };
  return (
    <>
      <footer>
        <hr />
        <div className="footer_container">
          <div className="contact_info">
            <h1>Contact info- </h1>
            <p>
              Feel free to reach out to me any time. I prefer to talk over
              email, especially since we may be a few time zones away.
            </p>
            <div className="mail">
              <i className="fas fa-envelope"> :</i>
              <a href="mailto:akshitrana21@gmail.com?subject=Hello Akshit!">
                akshitrana21@gmail.com
              </a>
            </div>{" "}
          </div>
          <div className="social">
            <h1>Follow me on-</h1>

            <a href="https://www.facebook.com/akshit.rana3" target={"_open"}>
              <i className="fab fa-facebook" title="Facebook"></i>
              Facebook{" "}
            </a>
            <a
              href="https://www.linkedin.com/in/akshit-rana-10"
              target={"_open"}
            >
              {" "}
              <i className="fab fa-linkedin" title="Linked in"></i>
              LinkedIn
            </a>
            <a href="https://github.com/Akshit3010" target={"_open"}>
              <i className="fab fa-github" title="GitHub"></i>
              GitHub
            </a>
            <a
              href="https://www.instagram.com/_akshit._.3010_"
              target={"_open"}
            >
              <i className="fab fa-instagram ig" title="Instagram"></i>
              Instagram
            </a>
          </div>
        </div>
        <div className="footer__content">
          <i className="far fa-copyright"></i> {date}{" "}
          <span>
            <NavLink to="/" onClick={goToTop}>
              Akshit Rana
            </NavLink>{" "}
            |{" "}
          </span>{" "}
          All rights reserved.
        </div>
      </footer>
    </>
  );
};

export default Footer;
